<template>
    <div style="display: inline-block ">
            <span v-if="!hiddenLabel" class="user-group-name">{{ $t('liveRoomManagement.liveRoomList.List.filter.userGroupTitle') }}</span>
                <Select
                    transfer 
                    class="selector"
                    :value="value"
                    @on-change="onChange"
                    size="small"
                    :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                    @on-select="selectUserGroup"
                    
                    > 
                    <!-- clearable  @on-clear=" resumeWhenClear" -->
                    <Option
                        v-for="item in userGroupList"
                        :value="item.id"
                        :key="item.label"
                        :label="item.label"
                    >{{ localize(item.name) }}</Option>
            </Select>
    </div>
</template>           

<script>
import api from "@/api/Api";
import extend from "extend";
import { mapState, mapMutations } from "vuex";
import apimodel from "@/model/ApiModel";
import helper from "@/assets/helper.js";
import config from "@/config";
import logger from "@/assets/log";

/*
    额外需求 NEED：
    NEED-1 输入完整名字后，自动选择
    NEED-2 手动清空输入后，需要显示可选列表
    NEED-3 外部可以获取label

*/
export default {
    props:["filterPath","value","hasPermission","hiddenLabel"],
    components: {
    },
    mixins: [
            {
                methods: helper
            }
    ],
    data() {
        return {
            selectedValue:this.value
        }
    },
    watch: {

    },
    computed: {
            ...mapState({
                userGroupList:state => state.user.userGroupList,
                isDepartmentAdmin: state => state.permission.isDepartmentAdmin,
                isSuperAdmin: state => state.permission.isSuperAdmin,
                originDefaultSelectedUserGroup:state => state.user.originDefaultSelectedUserGroup
            }),
    },
    methods: {
        resumeWhenClear(){
            this.$store.commit("user/setDefaultSelectedUserGroup",this.originDefaultSelectedUserGroup);
        },
        selectUserGroup(group){
            this.$store.commit("user/setDefaultSelectedUserGroup",group.value);
         },
        hasDepPermission(){
            if(this.filter.depId && this.filter.depId != 0){
                if(this.isSuperAdmin || this.isDepartmentAdmin){
                    return true;
                }else return !!this.hasPermission('selectliveRoomData');
            }else {
                return false;
            }
        },
        onChange(value) {
            this.$emit('input', value);
        }
    },
    mounted() {

    }
};
</script>


<style lang="less" scoped>
  .user-group-name{
      width: 100px;
  }
</style>